export const GET_TYPE_POSITION = 'GET_TYPE_POSITION'
export const GET_TYPE_POSITION_EXITO = 'GET_TYPE_POSITION_EXITO'
export const GET_TYPE_POSITION_ERRROR = 'GET_TYPE_POSITION_ERROR'
